import CmsSlider from "../../componets/CmsSlider";
import brandsData from "../../data/logoAndBrandingBrands.json";
import Divider from "../../componets/Divider";

export default function Section7() {
  const settings = {
    arrows: false,
    dots: true,
    infinite: true, 
    slidesToShow: 5, 
    slidesToScroll: 1, 
    autoplay: false, 
    cssEase: "linear", 
    responsive: [
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="Section7">
      <div className="section7-container">
        <h2 className="leading-[29px] md:leading-[41px] text-center text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
          Our Designed Logos
        </h2>

        <div className="w-full py-[1%] mx-auto md:w-[750px] lg:w-[970px] xl:w-[1170px]">
          <CmsSlider settings={settings} slides={brandsData} />
        </div>
      </div>
      <Divider marginStyle="" />
    </div>
  );
}
